import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './header/header.component';

import { FooterComponent } from './footer/footer.component';
import { LoaderComponent } from '../../components/loader/loader.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { NotificationPopupComponent } from '../../components/notification-popup/notification-popup.component';
import { NotificationCenterService } from '../../../Utils/_services/admin/notifications/notification-center.service';

@Component({
  selector: 'app-admin-layout',
  standalone: true,
  imports: [
    RouterModule,
    HeaderComponent,
    SidebarComponent,
    FooterComponent,
    LoaderComponent,
    NotificationPopupComponent
],
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.css'
})
export class AdminLayoutComponent {
  isSidebarCollapsed = false;
  
  constructor(notificationCenter: NotificationCenterService) {
    // Start listening for live alerts for the whole admin session
    notificationCenter.init();
  }
  
  toggleSidebar() {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }
}
